import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=ad30e014&scoped=true&"
import script from "./index.page.vue?vue&type=script&lang=js&"
export * from "./index.page.vue?vue&type=script&lang=js&"
import style0 from "./index.page.vue?vue&type=style&index=0&id=ad30e014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad30e014",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad30e014')) {
      api.createRecord('ad30e014', component.options)
    } else {
      api.reload('ad30e014', component.options)
    }
    module.hot.accept("./index.page.vue?vue&type=template&id=ad30e014&scoped=true&", function () {
      api.rerender('ad30e014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderDetail/index.page.vue"
export default component.exports